<template>
  <v-container>
    <v-row justify="center">
      <v-col
        cols="12"
        md="9"
        class="text-center my-5">
        <div class="videoWrapper">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/fGcsrsCP3pQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="text-center my-5">
        <div class="fill-height chatWrapper">
          <iframe height="480"src="https://www.youtube.com/live_chat?is_popout=1&v=fGcsrsCP3pQ&embed_domain=www.entregoals.com" frameborder="0"></iframe>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LiveStream',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
.videoWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
}
.videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.chatWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
}
.chatWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 480;
}
</style>
